import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '@core/utils/styles';

const LoadingState = ({ text }: { text?: string }) => {
  const { t } = useTranslation();
  const loadingText = text || t('common.loading');

  return (
    <>
      <Loader2 className={cn('size-4 animate-spin', loadingText ? 'mr-2' : '')} />
      {loadingText}
    </>
  );
};

export default LoadingState;
